import {Component, OnInit, ViewChild} from '@angular/core';
import {QuestionInfo, QuestionInfoChatItem} from '../../model/question.model';
import {BehaviorSubject} from 'rxjs';
import {ChatService} from '../chat.service';
import {ActivatedRoute} from '@angular/router';
import {UserAnswerMode, UserAnswerStateMode} from '../../model/user-answer.mode';
import {switchMap} from 'rxjs/operators';
import {PreloaderService} from "../../service/preloader.service";
import {Router} from '@angular/router';
import {BlockModel} from '../../model/block.model';

import {SlickCarouselComponent} from "ngx-slick-carousel";
import {QuizService} from "../../service/quiz.service";
import {FIELD_TYPES} from "../../config/fieldTypes.config";

@Component({
    selector: 'app-quiz',
    templateUrl: './quiz.component.html',
    styleUrls: ['./quiz.component.scss']
})
export class QuizComponent implements OnInit {
    questionsList: (QuestionInfo & QuestionInfoChatItem)[] = [];
    allQuestionsList: (QuestionInfo & QuestionInfoChatItem)[] = [];
    removedQuestion: (QuestionInfo & QuestionInfoChatItem)[] = [];
    selectedBlockId: number;
    currentQuestion: QuestionInfo;
    editing: boolean;
    answerStatus: number;
    questionsTotal: number;
    categoriesList = [];

    backLink = "/blocks";
    hideMenuBtn = true;
    nextBlock = '';
    progress = 0;
    message = '';
    avatar = '';

    selectEarningOver1KQuestion = {
        "answer": "Et beatae Nam elit",
        "answerLength": 900,
        "fieldTitle": "Type other Issue in max 900 characters",
        "fieldType": "textarea",
        "questionId": 97,
        "questionTitle": "Please Provide us a detailed synopsis of your situation, and how we can help. We will review it and let you know if it’s something we think we can effectively accomplish."
    };

    blocks: BlockModel[];

    groupEnd = {
        status: false,
        message: ''
    };

    popupMessage = {
        show: false,
        message: 'text',
        success: true
    }

    newElement = null;
    scrollValue = 0;

    slideConfig = {
        slidesToShow: 5,
        infinite: false,
        arrows: false,
        initialSlide: this.selectedBlockId
    };

    stopChat = false;
    showThanks = false;
    showAbout = false;
    infoThankYouText = '<br><h4>THANK YOU</h4> <br> We have all the information we need to assess your SSA Claim.<br><br> Your information will be sent to an SSLG Intake Attorney. If we beleive we can win your case, we will contact you by telephone and explain the process and next steps.<br><br> From there, we will send you the necessary SSA and SSLG forms that are necessary to represent you and timely file your appeal. If you have any questions, you can contact us at:<br><br> <span><a href="tel:+18009097754">800-909-7754</a><span> <br><br>';
    
    aboutUsText = "<br><div class='text-center'><h4>ABOUT US</h4></div> <ul><li>Since 1994, we\'ve successfully secured Title 2 (SSDI) and Title 16 (SSI) benefits for over 82,000 Disabled Americans and counting. </li><br> <li>Our Law Practice is dedicated exclusively to SSA Claims </li><br> <li>Our Technology Platform which we launched in December 1999 and have upgraded to the changing technologies is second to none. <br><br> As an SSLG Client, you can </li><br> <li>Check the status of your case on our Status Star Platform Download SSA forms which have been pre-populated with your medications, work history, etc.<br> Upload Medical Records to SSLG for submission to SSA. <br>Read Case Notes and other developments in your claim. <br>Watch hours of instructional video about the SSA process. <br>Receive e-mail and text alerts about your case. <br>Communicate with us via Video Conferencing calls. <br>Use Speech To Text to complete forms and send messages to us.</li></ul> <div class='text-center'><p>AND MUCH MORE</p></div><br>"
    @ViewChild('slickItems', {static: false}) slickItems: SlickCarouselComponent;


    constructor(private chatService: ChatService, private route: ActivatedRoute, private quizService: QuizService, private preloaderService: PreloaderService, private router: Router) {

    }

    ngOnInit() {
        console.log(this.chatService.getLastScreen());
        
        // if(this.chatService.getLastScreen().showThanks){
           
        // }
        this.initChat();
    }

    ngAfterViewInit() {
        // this.slickItems.config.initialSlide = this.selectedBlockId - 1;

        // this.chatService.getChat(this.selectedBlockId).subscribe((chat: any) => {
        //     let categories = chat.categories;
        //     if(categories.status){
        //         this.categoriesList = categories.result;
        //
        //         if (this.selectedBlockId - 1 > this.categoriesList.length - 5) {
        //             this.slickItems.config.initialSlide = this.selectedBlockId - 6;
        //         }
        //     }
        // });
    }

    answerSubmitted(answer: UserAnswerStateMode) {

        // {questionId: 66, title: '', optionId: 11, elementTitle: '1/19/2024'}

        // if(answer.questionId == 66 && answer.optionId == '10'){
        //     this.removedQuestion = this.allQuestionsList.splice(-2);
        //     this.allQuestionsList.splice(-2).map(function(e) {
        //         if(e.choices){
        //             e.choices.map(function(ne){
        //                 console.log(ne);
                        
        //             })
        //         }
        //         const nullAnswer = e.choices ? {questionId: e.questionId, title:''} : {questionId: e.questionId, title:''}
        //         this.answerSubmitted(nullAnswer);
        //     });
        //     console.log(this.allQuestionsList);
        // }
        if (!answer.notSave) {
            //this.preloaderService.show();
            this.chatService.setAnswer(answer).subscribe(rez => {
                // rez['answerListId'] = 222;
                // console.log('fd', rez);
                if (rez['status']) {
                    this.allQuestionsList.forEach(el => {


                        if (answer.optionId) {
                            if (el.questionId === answer.questionId) {
                                el.answerElement = answer.optionTitle ? answer.optionTitle : null;

                                if (el.choices) {
                                    const newElements = el.choices.find(newEl => +newEl.value === +el.answer).newElements;
                                    if (newElements) {
                                        const answeredNewElement = newElements.find(newAnsweredElement => +newAnsweredElement.optionId === +answer.optionId)
                                        answeredNewElement.answer = answer.elementTitle;
                                    }
                                }
                            }
                        } else {
                            if (el.questionId === answer.questionId) {

                                if ((el.fieldType === FIELD_TYPES.textList || el.fieldType === FIELD_TYPES.textListTwo) && (!el.answerList || answer.title !== 'done')) {
                                    if (!el.answerList) {
                                        el.answerList = [];
                                    }

                                    if (answer.answerListId === 0) {
                                        let answerListItemId = 0;
                                        let answerListId = 0;
                                        el.answerList.forEach(el => {
                                            answerListId = el.answer_id;
                                            if (el.id > answerListItemId) {
                                                answerListItemId = el.id;
                                            }
                                        });

                                        el.answerList.push({
                                            id: rez['answerListId'],
                                            "answer_id": answerListId,
                                            title: answer.answerListTitle,
                                            label: (el.fieldType === FIELD_TYPES.textListTwo && el.answerList.length%2===0) ? 'Job Title-'+(Math.floor(el.answerList.length/2)+1) : 'Industry-'+(Math.floor(el.answerList.length/2)+1)
                                        });
                                    } else {
                                        el.answerList.forEach(listItem => {
                                            if (listItem.id === answer.answerListId) {
                                                listItem.title = answer.answerListTitle;
                                            }
                                        });
                                    }

                                } else {
                                    el.answer = answer.title;
                                }

                            }
                        }
                    });
                    setTimeout(() => {
                        this.updateQuestions();
                        this.updateProgress();
                    });
                } else {
                    console.log(rez['message'])
                    this.showErrorPopup(rez['message']);
                }
            }, () => {
                this.showErrorPopup('Something went wrong, please try again')
            }, () => {
                //this.preloaderService.hide();
            });
        } else {
            this.allQuestionsList.forEach(el => {
                if (el.questionId === answer.questionId) {
                    this.currentQuestion = el;
                }
            });
        }

    }

    showSuccessPopup(message) {
      this.popupMessage.show = true;
      this.popupMessage.success = true;
      this.popupMessage.message = message;
    }

    showErrorPopup(message) {
        this.popupMessage.show = true;
        this.popupMessage.success = false;
        this.popupMessage.message = message;
    }

    closePopup() {
        this.popupMessage.show = false;
        this.popupMessage.success = false;
        this.popupMessage.message = '';
    }

    private initChat() {
        this.route.paramMap.subscribe(param => {
            this.selectedBlockId = +param.get('id');
            this.showThanks = JSON.parse(this.chatService.getLastScreen().showThanks);
            this.showAbout = JSON.parse(this.chatService.getLastScreen().showAbout);

            this.chatService.getChat(this.selectedBlockId).subscribe((chat: any) => {

                if (chat.status) {
                    this.progress = chat.progress;
                    this.avatar = chat.avatar;
                    this.categoriesList = chat.groups;
                    // this.categoriesList.splice(-2);

                    this.allQuestionsList = chat.questions;
                    // this will remove last two questions from the list.
                    // if(this.selectedBlockId==5)
                    //     this.allQuestionsList.splice(-2);
                    // if(this.selectedBlockId==8)
                    //     this.allQuestionsList.splice(-4);
                    
                    this.questionsTotal = this.allQuestionsList.length;
                    this.blocks = chat.groups;

                    this.resetGroupEnd();
                    this.updateQuestions();
                    this.updateProgress();
                    this.setNextBlockId();
                    
                } else {
                    // show error message
                }
            });
        });

    }

    resetGroupEnd() {
        this.groupEnd.status = false;
        this.groupEnd.message = '';
    }

    updateProgress() {
        const allQuestions = this.allQuestionsList.length;
        const answeredQuestions = this.allQuestionsList.filter(el => el.answer).length;
        this.progress = this.groupEnd.status ? 100 : Math.round(answeredQuestions / allQuestions * 100);
        // if(this.selectedBlockId==8 && this.progress==50)
        //     this.progress = 100;

        this.blocks.find(el => el.id === this.selectedBlockId).progress = this.progress;
    }

    updateQuestions() {
        let isNext = true;
        this.questionsTotal = 0;
        this.questionsList = [];
        this.groupEnd.status = false;
        this.groupEnd.message = '';

        this.allQuestionsList.forEach(el => {
            const elPosInAllQuestions = this.allQuestionsList.map(function(e) {
                return e.questionId;
            }).indexOf(el.questionId);


            if(el.fieldType === FIELD_TYPES.textMessage && elPosInAllQuestions === 0){
                this.questionsTotal += 1;
                this.questionsList.push(el);
                if (this.allQuestionsList[this.allQuestionsList.length - 1].questionId === el.questionId) {
                    this.groupEnd.status = true;
                    this.currentQuestion = null;
                }
            }else{
                if ((el.answer || (el.fieldType === FIELD_TYPES.textMessage && this.allQuestionsList[elPosInAllQuestions - 1].answer)) && !this.groupEnd.status && isNext) {
                    if (el.fieldType === FIELD_TYPES.textMessage) {
                        
                        this.questionsTotal += 1;
                        
                        this.questionsList.push(el);
                        if (this.allQuestionsList[this.allQuestionsList.length - 1].questionId === el.questionId) {
                            this.groupEnd.status = true;
                            this.currentQuestion = null;
                        }
                    } else {
                        this.questionsTotal += 1;
                        
                        this.questionsList.push(el);
                        // if (this.allQuestionsList[this.allQuestionsList.length - 1].questionId === el.questionId) {
                        //     this.groupEnd.status = true;
                        //     this.currentQuestion = null;
                        // }
                    }
    
                    const hasChoices = el.choices;
    
    
    
                    if (hasChoices) {
                        const selectedChoice = el.choices.find(choice => +choice.value === +el.answer);

                        if (selectedChoice.groupEnd || this.allQuestionsList[this.allQuestionsList.length - 1].questionId === el.questionId && el.answer && (!selectedChoice.newElement || selectedChoice.newElement && el.answerElement) && !selectedChoice.newElements) {
                            this.groupEnd.status = true;
                            this.groupEnd.message = selectedChoice.groupEndMessage ? selectedChoice.groupEndMessage : '';
                            this.currentQuestion = null;
                            if (this.groupEnd.message) {
                                this.stopChat = true;
                                // if(this.selectedBlockId===1)
                                //     this.goBackChatQuiz('application');
                                // else if(this.selectedBlockId===5)
                                //     this.goBackChatQuiz('appeal');
                            }
                        } else {
                            this.stopChat = false;
                        }
    
                        if (selectedChoice.newElement) {
                            this.newElement = selectedChoice.newElement;
                            this.questionsTotal += 1;
    
                            if (!el.answerElement) {
                                isNext = false;
    
                                const additionQuestiion: (QuestionInfo & QuestionInfoChatItem) = {
                                    fieldType: this.newElement.fieldType,
                                    questionId: el.questionId,
                                    optionId: this.newElement.optionId,
                                    questionTitle: this.newElement.title,
                                    selected: false,
                                    editing: false,
                                    hasAnswer: false
                                }
                                console.log(additionQuestiion);
                                
                                this.questionsList.push(additionQuestiion);
                                this.currentQuestion = additionQuestiion;
                            } else {
                                const additionQuestiion: (QuestionInfo & QuestionInfoChatItem) = {
                                    fieldType: this.newElement.fieldType,
                                    questionId: el.questionId,
                                    optionId: this.newElement.optionId,
                                    questionTitle: this.newElement.title,
                                    answer: el.answerElement,
                                    selected: false,
                                    editing: false,
                                    hasAnswer: false
                                };
                                console.log(additionQuestiion);
                                
                                this.questionsList.push(additionQuestiion);
                            }
    
                        }
    
                        if (selectedChoice.newElements) {
                            let showNext = true;
    
                            if (this.allQuestionsList[this.allQuestionsList.length - 1].questionId === el.questionId) {
                                let setGroupEnd = true;
                                const newElements = selectedChoice.newElements;
    
                                if (newElements) {
                                    if (!newElements[newElements.length - 1].answer) {
                                        setGroupEnd = false;
                                    }
                                }
    
                                if (setGroupEnd) {
                                    this.groupEnd.status = true;
                                    this.currentQuestion = null;
                                }
                            }
    
                            selectedChoice.newElements.forEach(newEl => {
                                this.newElement = newEl;
                                this.questionsTotal += 1;
    
                                if (showNext) {
                                    if (!newEl.answer) {
                                        isNext = false;
                                        showNext = false;

                                        const additionQuestiion: (QuestionInfo & QuestionInfoChatItem) = {
                                            fieldType: this.newElement.fieldType,
                                            questionId: el.questionId,
                                            optionId: this.newElement.optionId,
                                            questionTitle: this.newElement.title,
                                            isElementsGroup: true,
                                            selected: false,
                                            editing: false,
                                            hasAnswer: false,
                                            choices: this.newElement.choices,
                                            answerLength: this.newElement.answerLength
                                        }
                                        this.questionsList.push(additionQuestiion);
                                        this.currentQuestion = additionQuestiion;
                                    } else {
                                        const additionQuestiion: (QuestionInfo & QuestionInfoChatItem) = {
                                            fieldType: this.newElement.fieldType,
                                            questionId: el.questionId,
                                            optionId: this.newElement.optionId,
                                            questionTitle: this.newElement.title,
                                            answer: this.newElement.answer,
                                            isElementsGroup: true,
                                            selected: false,
                                            editing: false,
                                            hasAnswer: false,
                                            choices: this.newElement.choices,
                                            answerLength: this.newElement.answerLength
                                        };
                                        
                                        this.questionsList.push(additionQuestiion);
                                    }
                                }
    
                            });
    
    
    
                        }
                    }
                    if(this.stopChat){
                        console.log(this.currentQuestion);
                        
                        // if(this.selectedBlockId==1)
                        //     this.goBackChatQuiz('application');
                        // else if(this.selectedBlockId == 5)
                        //     this.goBackChatQuiz('appeal');

                    }
                    if((this.selectedBlockId==8 || this.selectedBlockId==4) && el.answer=='done'){
                        this.showThanks = true;
                        this.chatService.setLastScreen(this.showThanks, this.showAbout);
                    }
    
                } else {
                    if (isNext && !this.groupEnd.status) {
                        isNext = false;
    
                        this.questionsList.push(el);
                        this.questionsTotal += 1;

                        if (el.fieldType === FIELD_TYPES.textList && el.answerList && el.answerList.length) {
                            const additionQuestiion: (QuestionInfo & QuestionInfoChatItem) = {
                                fieldType: FIELD_TYPES.radio,
                                parentFieldType: FIELD_TYPES.textList,
                                questionId: el.questionId,
                                questionTitle: '',
                                choices:[
                                    {label:"Add","value": 'add'},
                                    {label:"Done","value": 'done'}
                                ],
                                selected: false,
                                editing: false,
                                hasAnswer: false
                            };
                            
                            this.currentQuestion = additionQuestiion;
    
                        }
                        // add new condition to get industry and job titles
                        else if(el.fieldType === FIELD_TYPES.textListTwo && el.answerList && el.answerList.length){
                            if(el.answerList.length%2===0){
                                const additionQuestiion: (QuestionInfo & QuestionInfoChatItem) = {
                                    fieldType: FIELD_TYPES.radio,
                                    parentFieldType: FIELD_TYPES.textListTwo,
                                    questionId: el.questionId,
                                    questionTitle: '',
                                    choices:[
                                        {label:"Add Another Job","value": 'add'},
                                        {label:"Done","value": 'done'}
                                    ],
                                    selected: false,
                                    editing: false,
                                    hasAnswer: false
                                };
                                this.currentQuestion = additionQuestiion;
                            }
                            else{
                                this.allQuestionsList.forEach(element => {
                                    if (element.questionId === el.questionId) {
                                        const additionQuestiion: (QuestionInfo & QuestionInfoChatItem) = {
                                        fieldTitle: "",
                                        fieldType: FIELD_TYPES.textListTwo,
                                        questionId: el.questionId,
                                        questionTitle: "",
                                        answerList: element.answerList
                                    }
                                    this.currentQuestion = additionQuestiion;
                                    }
                                });
                            }
                        }

                        else {
                            this.currentQuestion = el;
                        }
                    }
                    console.log(this.groupEnd.status);
                    
                    if (this.groupEnd.status) {
                        this.currentQuestion = null;
                        if (this.groupEnd.message) {
                            this.stopChat = true;
                        }
                    } else {
                        this.stopChat = false;
                    }
                }
            }
        });

        setTimeout(() => {
            const element = document.querySelector('.scrolled__inner');
            element.scroll({ top: element.scrollHeight, behavior: 'smooth' });

            this.setNextBlockId();
        }, 0);
    }

    setNextBlockId(){
        let total = this.categoriesList.length;
        let selectedIndex = 0;
        for(let i=0;i<total;i++){
            if(this.categoriesList[i].id == this.selectedBlockId){
                selectedIndex = i;
            }
        }

        if(selectedIndex < (total - 1)){
            this.nextBlock = this.categoriesList[selectedIndex+1].id;
            if (this.stopChat) {
                this.nextBlock = null;
            }
        } else {
          this.nextBlock = null;
        }
    }

    onEditing($event: boolean) {
        const editing = $event
        const changed = this.editing !== $event;
        this.editing = editing;
        // const chatElement = (document.body.querySelector('.app-chat') as HTMLElement);
        // const scrolledElement = (document.body.querySelector('.scrolled') as HTMLElement);
        // const position = editing ? 'absolute' : 'static';
        // let height = chatElement.offsetHeight;

        if (changed) {
            if (editing) {
              (document.body.querySelector('.scrolled__inner') as HTMLElement).style.overflow = 'hidden';
              setTimeout(() => {
                  if ((document.body.querySelector('.chat-message__edit') as HTMLElement)) {
                      const editTop = (document.body.querySelector('.chat-message__edit') as HTMLElement).getBoundingClientRect().top;
                      const minEditTop = (window.innerHeight - 40 - (document.body.querySelector('.chat-message__edit') as HTMLElement).getBoundingClientRect().height);
                      if (editTop > minEditTop) {
                          (document.body.querySelector('.scrolled__inner') as HTMLElement).scrollTop += (editTop - minEditTop);
                      }
                  }
              }, 250);
                // this.scrollValue = scrolledElement.scrollTop ? scrolledElement.scrollTop + 23 : 0;
                // const scrollDist = scrolledElement.scrollHeight - scrolledElement.offsetHeight - scrolledElement.scrollTop;
                // //chatElement.style.top = scrollDist || this.scrollValue ? '0' : this.currentQuestion ? '-75px' : '0';
                // // chatElement.style.top = '20px';
                // console.log(scrollDist, this.scrollValue, this.currentQuestion)
                // if ((scrollDist && scrollDist > 5) || (this.scrollValue && this.scrollValue > 28)) {
                //     if (this.currentQuestion) {
                //         if ((scrollDist < 5) || (this.scrollValue < 28)) {
                //             if (this.currentQuestion.fieldType === FIELD_TYPES.radio) {
                //               chatElement.style.top = '-50px';
                //             } else {
                //               chatElement.style.top = '-75px';
                //             }
                //
                //         } else {
                //           if (this.currentQuestion.fieldType === FIELD_TYPES.radio) {
                //             chatElement.style.top = '75px';
                //           } else {
                //             chatElement.style.top = '105px';
                //           }
                //         }
                //     } else {
                //         chatElement.style.top = '105px';
                //     }
                //   // chatElement.style.top = '15px';
                //   console.log(scrollDist, this.scrollValue, chatElement.style.top, 'scroll')
                // } else {
                //     if (this.currentQuestion) {
                //       if (this.currentQuestion.fieldType === FIELD_TYPES.radio) {
                //         chatElement.style.top = '-65px';
                //       } else {
                //         chatElement.style.top = '-75px';
                //       }
                //     } else {
                //         chatElement.style.top = '0';
                //     }
                //   console.log(scrollDist, this.scrollValue, chatElement.style.top, 'no scroll')
                // }
                // console.log(scrollDist, this.scrollValue, chatElement.style.top, 'common')
            } else {
              // (document.body.querySelector('.scrolled__inner') as HTMLElement).style.overflow = 'hidden';
              //   chatElement.removeAttribute('style');
                // scrolledElement.scrollTop = this.scrollValue;
                // height = 0;
                // (document.querySelector('.progress') as HTMLElement).removeAttribute('style');
                // (document.querySelector('.scrolled') as HTMLElement).style.overflow = 'auto';
                (document.body.querySelector('.scrolled__inner') as HTMLElement).style.overflow = 'auto';
            }
            // chatElement.style.position = position;
            // (document.querySelector('.editing-placeholder') as HTMLElement).style.paddingBottom = height + 'px';
        }
    }

    checkActiveCategory(category){
        if(category.id == this.selectedBlockId){
            return `is-active`;
        }

        return '';
    }

    checkActiveDot(categoryId){
        if(categoryId == this.selectedBlockId){
            return `is-active`;

        }

        return '';
    }

    setClassOfBlockProgress(block, doneClass, progressClass, disabledClass) {
        if (block.odr !== this.blocks[0].odr) {
            let lastEditingBlock = this.blocks[0];
            let lastEditingBlockIndex = 0;


            this.blocks.forEach((bl, index) => {
                if (bl.progress && lastEditingBlock.odr < bl.odr) {
                    lastEditingBlock = bl;
                    lastEditingBlockIndex = index;
                }
            });

            if (lastEditingBlock.progress === 100) {
                if (lastEditingBlockIndex !== (this.blocks.length - 1)) {
                    lastEditingBlockIndex += 1;
                    lastEditingBlock = this.blocks[lastEditingBlockIndex];
                }
            }

            if ((block.odr > lastEditingBlock.odr && lastEditingBlock.progress !== 100) || (block.odr <= lastEditingBlock.odr && this.stopChat)) {
                return disabledClass;
            }
        }

        if (block.progress !== 100 && (this.selectedBlockId === block.id && !this.groupEnd.status)) {
            return progressClass;
        }

        return doneClass;
    }

    getDotClass(block){
        return this.setClassOfBlockProgress(block, 'is-done', 'is-progress', 'is-disabled');
    }

    getClass(block) {
        const progressClass = 'progress__item--is-active perc-'+this.setBlockProgress(block.progress);
        return this.setClassOfBlockProgress(block, 'is-done', progressClass, 'progress__item--is-done');
    }

    setBlockProgress(progress) {
        let result = 0;

        if (progress < 10) {
            result = 0;
        } else if (progress < 20) {
            result = 10;
        } else if (progress < 30) {
            result = 20;
        } else if (progress < 40) {
            result = 30;
        } else if (progress < 50) {
            result = 40;
        } else if (progress < 60) {
            result = 50;
        } else if (progress < 70) {
            result = 60;
        } else if (progress < 80) {
            result = 70;
        } else if (progress < 90) {
            result = 80;
        } else if (progress < 100) {
            result = 90;
        }
        return result;
    }

    startQuiz(block) {
        if(!block.hidden){
            this.preloaderService.show();

            let $this = this;
            setTimeout(function () {
                if(block.id!==8){
                    $this.chatService.setLastScreen(false, false);
                }
                $this.router.navigate(['/chat/' + block.id]);
                // if (block.id - 1 > $this.blocks.length - 5) {
                //     $this.slickItems.config.initialSlide = this.block.id - 6;
                // } else {
                //     $this.slickItems.slickGoTo(block.id - 1);
                // }

                $this.preloaderService.hide();
            },200);
        }
    }
    finishChat(){
        this.showAbout = true;
        this.chatService.setLastScreen(this.showThanks, this.showAbout);
    }
    quitChat(){
        this.router.navigate(['/dashboard']);
    }
    goBack(screen){
        if(screen==='quiz'){
            this.showThanks = false;
            this.showAbout = false;
        }
        else{
            this.showThanks = true;
            this.showAbout = false;
        }
        
        this.chatService.setLastScreen(this.showThanks, this.showAbout);
    }

    goNext(){
        this.showThanks = true;
        this.chatService.setLastScreen(this.showThanks, this.showAbout);
    }

    hideEdit(state) {
        this.editing = false;
    }

    goBackChatQuiz(type) {
        this.router.navigate(['/dashboard'], {queryParams: {
            'type': type
          }});
    }
}
